export default __webpack_public_path__ + "static/media/Steward_Particle_0002_Layer-69.a2a897c8.png";